export const storage = {
  CODE: "code",
  COMPANY_NAME: "companyname",
  DOMAIN: "domain",
  SESSION: "session",
  /** Direct transfer flow: chosen asset for direct deposit screen (set on payment-options) */
  DIRECT_TRANSFER_SYMBOL: "directTransferSymbol",
  DIRECT_TRANSFER_NETWORK: "directTransferNetwork",
  DIRECT_TRANSFER_ICON: "directTransferIcon",
  /** EVM chain ID from direct_deposit_networks.chain_id (Solana uses DB value) */
  DIRECT_TRANSFER_CHAIN_ID: "directTransferChainId",
  /** One-time display payload for insufficient direct deposit result page */
  DIRECT_DEPOSIT_INSUFFICIENT_RESULT: "directDepositInsufficientResult",
  /** Client Back/restore guard: "false" | "already_paid" | "payment_failed" */
  SESSION_COMPLETED: "sessionCompleted",
  /** Source step to return to from third-party payment options */
  THIRD_PARTY_BACK_TARGET: "thirdPartyBackTarget",
  /** Flag set when Turbo performs browser history restoration */
  TURBO_RESTORE_PENDING: "turboRestorePending",
  /** One-time guard to avoid reload loops on restore */
  TURBO_RESTORE_RELOADED: "turboRestoreReloaded",
  /** DirectDeposit Explorer URL */
  DIRECT_DEPOSIT_EXPLORER_URL: "directDepositExplorerURL",
  /** WM funnel: first timestamp (ms) for time_in_wm_ms Statsig metadata */
  WM_FUNNEL_START_MS: "wmFunnelStartMs",
  /** WM funnel: last wallet balance (USD) after waas_funded — used to derive purchase increment */
  WM_LAST_BALANCE_USD: "wmLastBalanceUsd",
}
